export const GA4_MEASUREMENT_ID = "G-29H1W8CZFN"
export const GTM_ID = "GTM-M4B92NGD"
